import axios from 'axios';

import { scanningConfig } from '../Config';
import { getToken } from '../helpers/AuthHelpers';

const baseURL = scanningConfig.apiPath;

const client = axios.create({
    baseURL,
    headers: {
        'Camel-Case': 'true'
    }
});

client.interceptors.request.use((config) => {
    const token = getToken('idToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export { client };
